import { AppIcon } from '@backrs_ui/common-ui';

import { Select, MenuItem, Typography, Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

type SelectMenuProps = Readonly<{
  value: string;
  onChange: (value: string) => void;
  title: string;
  options: { value: string; label: string }[];
}>;

export const SelectMenu = ({ value, onChange, title, options }: SelectMenuProps) => {
  return (
    <Box sx={containerStyles}>
      <Select
        value={value}
        onChange={(event) => onChange(event.target.value as string)}
        sx={menuStyles}
        displayEmpty
        renderValue={() => (
          <Box sx={renderValueContainer}>
            <Typography sx={menuTitle}>{title}</Typography>
            <AppIcon iconName="ChevronDown" diameter="16px" color="Colors/Text/text-primary" />
          </Box>
        )}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

const containerStyles: SxProps<Theme> = {
  position: 'relative',
  width: 'fit-content',
}

const menuStyles: SxProps<Theme> = {
  height: '28px',
  width: '100%',
  padding: '0px 10px',
}

const renderValueContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  gap: '4px',
}

const menuTitle: React.CSSProperties = {
  fontSize: '10.5pt',
  fontWeight: '500',
};

